





































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { IGetRgAvailableItemListResponse, searchUser, getRgAvailableItemList, IChatFormData, saveRobotInfo } from '@/api/rg';
import { orgDetailByPath } from '@/api/cti';
import QuillEditorMarkdown from '@/views/components/quill-editor-markdown.vue';
import * as api from '@/api';

@Component({
    components: {
        QuillEditorMarkdown
    }
})
export default class EdiLinkForm extends Vue {
    @Prop({ type: Array, required: true }) readonly robotConfigs!: IChatFormData[];
    fetchingEdiInfo: boolean = false;
    isReady: boolean = false;
    searchLoading: boolean = false;
    editor: any;
    private formData: IChatFormData = {
        type: '',
        applyScenario: ['TT_CREATE', 'DX'],
        llmWelcomeConf: {
            defaultQuestion: [],
            welcome: ''
        },
        llmHumanServiceTransferConf: {
            dxTransHumanLink: '',
            dxTransHumanCtiEnabled: false
        },
        itemList: [],
        llmAppLink: '',
        xueChengListString: '',
        authorizedOrgList: [],
        authorizedUserList: [],
        isDialogueForced: false,
        robotName: '',
        llmRobotId: ''
    } as any;
    private _rgId: number | undefined;
    orgDetailList: any = [];
    userList: CommonTypes.UserInfoItem[] = [];
    rgItemList: IGetRgAvailableItemListResponse['items'] = [];
    isSubmitting: boolean = false;
    tempRobotId: string = '';

    private get showMainLink() {
        if (!this.formData.llmAppLink || this.formData.llmAppLink.length === 0) {
            return false;
        }
        return true;
    }

    private get showHumanServiceConfig() {
        if (!this.formData.applyScenario || this.formData.applyScenario.length === 0) {
            return false;
        }
        return this.formData.applyScenario.includes('DX');
    }

    private get showItemConfig() {
        if (!this.formData.applyScenario || this.formData.applyScenario.length === 0) {
            return false;
        }
        return this.formData.applyScenario.includes('TT_CREATE');
    }

    private get isShowAddDefaultQuestionButton() {
        if (!this.formData.llmWelcomeConf || !this.formData.llmWelcomeConf.defaultQuestion) {
            return true;
        }

        return this.formData.llmWelcomeConf.defaultQuestion.length < 5;
    }

    private get rules() {
        return {
            robotName: [
                {
                    required: true,
                    trigger: ['blur'],
                    message: '机器人名称不能为空'
                }
            ],
            xueChengListString: [
                {
                    required: true,
                    trigger: ['blur'],
                    validator: (rule, value, callback) => {
                        function validateLinks(input) {
                            const regex =
                                /^(https:\/\/(km\.sankuai\.com|km\.it\.test\.sankuai\.com)\/[^\s,]+)(,(https:\/\/(km\.sankuai\.com|km\.it\.test\.sankuai\.com)\/[^\s,]+))*$/;
                            return regex.test(input);
                        }

                        if (!value) {
                            callback(new Error('学城链接不能为空，请在EDI后台维护后重新点击“绑定EDI应用”'));
                        } else if (!validateLinks(value)) {
                            callback(new Error('学城链接格式错误'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            applyScenario: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!value || value.length === 0) {
                            callback(new Error('应用场景不能为空'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            itemList: [
                {
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.showItemConfig && (!this.formData.itemList || this.formData.itemList.length === 0)) {
                            callback(new Error('请至少选择一个目录'));
                        }
                        callback();
                    }
                }
            ],
            llmHumanServiceTransferConf: [
                {
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.showHumanServiceConfig && !value.dxTransHumanLink) {
                            callback(new Error('请输入大象转人工链接'));
                        }
                        callback();
                    }
                }
            ],
            authorizedOrgList: [
                {
                    trigger: 'blur',
                    message: '请至少选择一个授权组织或授权用户',
                    validator: (rule, value, callback) => {
                        const hasOrgs = this.formData.authorizedOrgList && this.formData.authorizedOrgList.length > 0;
                        const hasUsers = this.formData.authorizedUserList && this.formData.authorizedUserList.length > 0;

                        if (!hasOrgs && !hasUsers) {
                            callback(new Error('请至少选择一个授权组织或授权用户'));
                        } else {
                            callback();
                        }
                    }
                }
            ]
        };
    }

    mounted() {
        this.editor = this.$refs.editor;
        this.isReady = true;
        this._initFormData();
        console.log('LINKmounted', this.formData);
    }

    private _initFormData() {
        if (this.robotConfigs.length > 0) {
            const robot = this.robotConfigs[0];
            this.formData.robotName = robot.robotName;
            this.formData.type = robot.type;
            const applyScenario = robot.applyScenario || [];
            //  默认添加TT_CREATE和DX
            if (!applyScenario.includes('TT_CREATE')) {
                applyScenario.push('TT_CREATE');
            }
            if (!applyScenario.includes('DX')) {
                applyScenario.push('DX');
            }

            this.formData.applyScenario = applyScenario;
            this.formData.llmWelcomeConf = robot.llmWelcomeConf;
            this.formData.llmHumanServiceTransferConf = (robot.llmHumanServiceTransferConf || {}) as any;
            this.formData.authorizedOrgList = robot.authorizedOrgList;
            this.formData.authorizedUserList = this._toAuthorizedUserList(robot.authorizedUserList);
            this.formData.isDialogueForced = !robot.isDialogueForced;
            this.formData.xueChengListString = this._toXueChengListString(robot.xueChengList);

            this.formData.llmAppLink = robot.llmAppLink;
            this.formData.openDxLink = robot.openDxLink;
            this.formData.llmRobotId = robot.llmRobotId;
            this.formData.itemList = this._toItemIdList(robot.itemList);
            this.formData.proxyRobotId = robot.proxyRobotId;
            this.formData.kmRootDocNum = robot.kmRootDocNum;
            this.formData.kmChildDocNum = robot.kmChildDocNum;
            // quill 编辑器传值
            this.editor.initFromMarkdown(robot.llmWelcomeConf?.welcome || '');

            this.tempRobotId = robot.llmRobotId;
        }
    }

    private _toXueChengListString(xueChengList: string[]): string {
        if (!xueChengList || xueChengList.length === 0) {
            return '';
        }

        return xueChengList.join(',');
    }

    /**
     * 后端返回是一个itemList，前端需要的是一个itemIdList.
     */
    private _toItemIdList(itemList: any): any[] {
        return itemList.map(v => v.itemId);
    }

    private _toAuthorizedUserList(authorizedUserList: any): string[] {
        return authorizedUserList.map(v => {
            return v.username;
        });
    }

    async fetchEdiRobotInfo() {
        if (!this.tempRobotId) {
            this.$mtd.message.error('请先输入机器人ID');
            return;
        }

        this.fetchingEdiInfo = true;
        try {
            const response = await api.smartApi.linkRobot(this.tempRobotId);

            if (response) {
                if (response.code !== 0) {
                    this.$mtd.message.error('保存失败, 原因:' + response.message);
                    return;
                }
                const robotInfo = response.data;

                const welcomeConf = JSON.parse(robotInfo.llmWelcomeConf || '{}');
                this.formData.llmWelcomeConf.defaultQuestion = welcomeConf.defaultQuestion || [];
                this.editor.initFromMarkdown(welcomeConf.welcome || '');

                this.formData.robotName = robotInfo.robotName || this.formData.robotName || '';
                this.formData.xueChengListString =
                    robotInfo.xueChengList && robotInfo.xueChengList.length > 0 ? robotInfo.xueChengList.join(',') : '';
                this.formData.kmRootDocNum = robotInfo.kmRootDocNum;
                this.formData.kmChildDocNum = robotInfo.kmChildDocNum;
                this.formData.llmHumanServiceTransferConf = JSON.parse(robotInfo.llmHumanServiceTransferConf || '{}');
                this.formData.llmAppLink = robotInfo.llmAppLink;
                this.formData.openAppKey = robotInfo.openAppKey;
                this.formData.openDxBotId = robotInfo.openDxBotId;
                this.formData.openDxLink = robotInfo.openDxLink;
                this.formData.llmRobotId = this.tempRobotId;

                this.$mtd.message.success('绑定成功');
            }
        } catch (error) {
            console.log(error);
            this.$mtd.message.error('绑定失败');
        } finally {
            this.fetchingEdiInfo = false;
        }
    }

    onOrgChange(orgList) {
        this.formData.authorizedOrgList = orgList.map(org => {
            return {
                orgId: org.orgId,
                orgName: org.orgName
            };
        });
    }

    addDefaultQuestion() {
        if (this.formData.llmWelcomeConf.defaultQuestion.length < 5) {
            this.formData.llmWelcomeConf.defaultQuestion.push('');
        } else {
            this.$message.warning('最多只能添加5条默认问题');
        }
    }

    removeDefaultQuestion(index: number) {
        this.formData.llmWelcomeConf.defaultQuestion.splice(index, 1);
    }

    stringToList = (listString: string) => {
        if (!listString) return [];

        return listString
            .split(',')
            .map(item => item.trim())
            .filter(item => item);
    };

    private _parseRgId(): number {
        return parseInt(this.$route.query.rgId as string, 10);
    }

    async created() {
        this._rgId = this._parseRgId();
        await this._initRgAvailableItems();
    }

    private handleKnowledgeLink() {
        window.open(this.formData.llmAppLink);
    }

    private handleDxRobotMaintain() {
        window.open(this.formData.openDxLink);
    }

    private async _initRgAvailableItems() {
        try {
            const { data, code } = await getRgAvailableItemList({ rgId: this._rgId });
            if (code === 200) {
                this.rgItemList = data.items;
            }
        } catch (_) {}
    }

    formatter(val) {
        if (val.value) {
            return `${val.value.orgName}`;
        }
    }

    handleIsDialogueForcedChange(b: boolean): void {
        const openDialogueConfirm = (): void => {
            this.$mtd
                .confirm({
                    title: '提示',
                    message: '此开关开启后将强制用户进入智能问答页面，为避免产生客诉，请您提前做好运营宣导。',
                    width: '400px',
                    type: 'warning',
                    okButtonText: '知道了'
                })
                .catch(() => {});
        };

        const isForce = !!b;
        if (isForce) openDialogueConfirm();
    }

    async searchOrg(query) {
        if (query.length < 1) {
            // this.orgDetailList = defaultOption;
            return;
        }
        this.searchLoading = true;
        try {
            const res = await orgDetailByPath(encodeURIComponent(query));
            const { data } = res;
            if (data) {
                this.orgDetailList = [data];
            } else {
                this.orgDetailList = [];
            }
        } catch (e) {
            console.log(e);
        }
        this.searchLoading = false;
    }

    async remoteMethod(query) {
        if (!query) return;
        this.searchLoading = true;
        try {
            const res = await searchUser({ keyword: query, includeExternal: true });
            this.userList = res.data.items as any;
        } catch (e) {
            this.userList = [];
        }
        this.searchLoading = false;
    }

    onUserChanged(userList) {
        this.formData.authorizedUserList = userList;
    }

    handleSubmit() {
        (this.$refs.form as any).validate(async (valid: boolean) => {
            if (!valid) {
                return;
            }

            this.isSubmitting = true; // 开始加载

            if (valid) {
                // 提交表单
                const payload: any = {
                    llmPlatform: 'EDI',
                    type: 'SMART_LINK',
                    robotName: this.formData.robotName,
                    llmRobotId: this.formData.llmRobotId,
                    llmWelcomeConf: {
                        ...this.formData.llmWelcomeConf,
                        welcome: this.editor.markdownContent
                    },
                    authorizedUserMisList: this.formData.authorizedUserList,
                    xueChengList: this.formData.xueChengListString.split(',').map(item => item.trim()),
                    authorizedOrgIdList: this.formData.authorizedOrgList.map(item => Number(item.orgId)),
                    llmHumanServiceTransferConf: {
                        type: 'EDI',
                        dxTransHumanCtiEnabled: this.formData.llmHumanServiceTransferConf.dxTransHumanCtiEnabled,
                        dxTransHumanLink: this.formData.llmHumanServiceTransferConf.dxTransHumanLink
                    },
                    isDialogueForced: !this.formData.isDialogueForced,
                    itemIdList: this.formData.itemList,
                    applyScenario: this.formData.applyScenario,
                    controlLevel: 'RG',
                    openAppKey: this.formData.openAppKey,
                    openDxBotId: this.formData.openDxBotId
                };

                /**
                 * 修改数据时
                 */
                const isUpdate = this.formData.proxyRobotId > 0;
                if (isUpdate) {
                    payload.proxyRobotId = this.formData.proxyRobotId;
                }

                try {
                    const result = await saveRobotInfo(this._rgId, payload);
                    if (result.code !== 200) {
                        this.$mtd.message.error('保存失败, 原因:' + result.message);
                    } else {
                        this.$mtd.message.success('保存成功');

                        // 修改场景不刷新
                        if (!isUpdate) {
                            setTimeout(() => {
                                location.reload();
                            }, 300);
                        }
                    }
                } catch (_) {
                    this.$mtd.message.error('保存失败');
                } finally {
                    this.isSubmitting = false;
                }
            }
        });
    }
}
